<div class="content">
  @if ((errorMessage()?.trim()?.length || 0) > 0) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  <h4>Here are the changes that we could detect since the previous revision.</h4>
  <h4>Please enter a description for each change where applicable - some descriptions have been pre-filled, but they can be changed if desired.</h4>
  <h4>Please enter any changes in the box at the bottom for changes that were not auto-detected.</h4>
  <div class="table-wrapper">
    <table class="data-table">
      <thead>
        <tr>
          <th class="top-header"></th>
          <th class="top-header" colspan="3">Previous Revision Level</th>
          <th class="top-header" colspan="3">Current Revision Level</th>
          <th class="top-header"></th>
        </tr>
        <tr>
          <th class="bottom-header">Line #</th>
          <th class="bottom-header">Rev #</th>
          <th class="bottom-header">Product</th>
          <th class="bottom-header">Qty</th>
          <th class="bottom-header">Rev #</th>
          <th class="bottom-header">Product</th>
          <th class="bottom-header">Qty</th>
          <th class="bottom-header">Description of Change (255 characters max)</th>
        </tr>
      </thead>
      <tbody>
        @if ((changes()?.length || 0) === 0) {
          <tr>
            <td colspan="8">No changes could be automatically detected for this revision</td>
          </tr>
        } @else {
          @for (change of changes(); track change.lineId) {
            <tr>
              <td>{{ change.lineId }}</td>
              <td>{{ change.previousRevisionId }}</td>
              <td>{{ change.previousProductNumber }}</td>
              <td>{{ change.previousQuantity }}</td>
              <td>{{ change.currentRevisionId }}</td>
              <td>{{ change.currentProductNumber }}</td>
              <td>{{ change.currentQuantity }}</td>
              <td class="input-cell">
                <textarea maxlength="255" cols="70" rows="3" class="fixed-text-area" [(ngModel)]="change.changeDescription"></textarea>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
  <div class="other-change-wrapper">
    <label for="otherChangeInput" class="text-area-label">Other changes:</label>
    <textarea id="otherChangeInput" maxlength="255" cols="130" rows="3" class="other-change-input" [(ngModel)]="otherChanges"></textarea>
  </div>
  <div class="button-wrapper">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialog-button warn-button" [disabled]="isBusy()" (click)="cancel()">Cancel Review</button>
    <button matButton="elevated" class="dialog-button primary-button" [disabled]="isBusy()" (click)="save()">Proceed with Review</button>
  </div>
</div>
